import Vue from "vue";
import router from "@/router/index";
/**
 * 获取 url 参数 问号后的参数
 * 如：xx.com?a=1&b=2
 * */
export function GetQueryString(name) {
  var result = location.href.match(new RegExp("[?&]" + name + "=([^&]+)", "i"));
  if (result == null || result.length < 1) {
    return "";
  }
  return result[1];
}

export function loadImageEnd(list, callback, basePath) {
  if (!list || list.length === 0) return;
  if (basePath) list = list.map((item) => basePath + item);
  let img = new Image();
  img.data = {
    list: list,
    callback: callback,
    resultList: [],
    num: 0,
  };
  img.addEventListener("load", loadImgHandler);
  img.addEventListener("error", loadImgHandler);
  img.src = list[img.data.num];
}

function loadImgHandler(e) {
  let data = e.currentTarget.data;
  if (e.type !== "error") {
    data.resultList.push(e.currentTarget.cloneNode(false));
  }
  data.num++;
  if (data.num > data.list.length - 1) {
    e.currentTarget.removeEventListener("load", loadImgHandler);
    if (data.callback) {
      data.callback(data.resultList);
    }
    data = null;
    return;
  }
  e.currentTarget.src = data.list[data.num];
}

export const getQueryStringBySearch = (search, name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = search.substr(1).match(reg);
  if (r != null) {
    return encodeURIComponent(r[2]);
  }
  return null;
};

/**
 * 使用场景: 鼠标不断点击触发，输入框中不断输入(单位时间内只触发一次)。
 * @description: 防抖函数
 * @param {Function} fn
 * @param {Number} wait
 * @return fn 函数
 */

export function debounce(fn, delay = 300) {
  let timer = null;
  return function () {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, arguments);
    }, delay);
  };
}

let padNum = (num) => {
  return num < 10 ? "0" + num : num;
};
// 普通日期的写法
export const dateTimeFiter = (num, type = "all") => {
  // 时间戳数据处理
  let date = new Date(num);
  if (num) {
    date = new Date(num);
  } else {
    date = new Date();
  }
  // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? "0" + MM : MM; // 月补0
  let d = date.getDate();
  d = this.padNum(d);
  let h = date.getHours();
  h = this.padNum(h);
  let m = date.getMinutes();
  m = this.padNum(m);
  let s = date.getSeconds();
  s = this.padNum(h);
  if (type == "yy/mm/dd") {
    return y + "/" + MM + "/" + d;
  } else if (type == "yy-mm-dd") {
    return y + "-" + MM + "-" + d;
  } else if (type == "yy-mm-dd hh:mm:ss") {
    return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
  } else {
    return y + "-" + MM + "-" + d + " " + h + ":" + m;
  }
};

export function isNull(_string) {
  return _string != "null" && _string != "" && _string != null;
}

/**
 * @description: 转换为query参数
 * @param {Object} opt
 * @returns query参数
 */
export function queryParams(opt) {
  let params = opt
    ? "?" +
      Object.keys(opt)
        .map((key) => key + "=" + opt[key])
        .join("&")
    : "";
  return params;
}

export function routerModule(path, param) {
  this.$router.push({
    path: path,
    query: param,
  });
}

export function replaceMoudule(path, param) {
  this.$router.replace({
    path: path,
    query: param,
  });
}

const filterLogo = (url, defaultFileICon) => {
  if (url) {
    let index = url.lastIndexOf(".") + 1;
    let postfixName = url.slice(index).toLowerCase();
    console.log("postfixName===", postfixName);
    if (postfixName == "xlsx" || postfixName == "xls") {
      return "https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/wmt-file-xls.png";
    } else if (postfixName == "ppt" || postfixName == "pptx") {
      return "https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/wmt-file-ppt.png";
    } else if (postfixName == "pdf") {
      return "https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/wmt-file-common.png";
    } else if (
      postfixName == "jpg" ||
      postfixName == "png" ||
      postfixName == "jpeg" ||
      postfixName == "gif"
    ) {
      return "https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/wmt-file-image.png";
    } else if (postfixName == "doc" || postfixName == "docx") {
      return "https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/wmt-file-w.png";
    } else if (postfixName == "mp4" || postfixName == "m3u8") {
      return "https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/wmt-file-video.png";
    } else if (postfixName == "csv") {
      return "https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/CSV.png";
    } else if (postfixName == "md") {
      return "https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/MD.png";
    } else if (postfixName == "txt") {
      return "https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/TXT.png";
    } else {
      return defaultFileICon;
    }
  } else {
    return defaultFileICon;
  }
};

const getFileUrl = (file) => {
  let url = file?.fileUrl || file?.previewUrl || file?.relationUrl || ""; // 文件地址
  let fileType = file?.fileType?.toString() || "-1"; // 文件类型
  // let defaultFileICon = 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/wmt-file-common.png'
  let defaultFileICon =
    "https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/wmt-file-not.png";
  // console.log("fileType===",fileType)
  // console.log("url===",url)
  console.log("url====", url);
  console.log("fileType====", fileType);
  switch (fileType) {
    case "1":
      return "https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/wmt-file-image.png";
    // 文件
    case "2":
      return filterLogo(url, defaultFileICon);
    // 视频
    case "3":
      return "https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/wmt-file-video.png";
    default:
      return filterLogo(url, defaultFileICon);
  }
};

export function isEmpty(_string) {
  return _string == "" || _string == null || _string == undefined;
}
import i18n from "@/lang/index";
export function isLogin(noJump = false) {
  return new Promise((resolve, reject) => {
    let token = localStorage.getItem("token");
    if (!!token) {
      resolve();
    } else {
      if (noJump) {
        reject();
      } else {
        Vue.prototype.$toast(i18n.t("lang.t310"));
        console.log(router);
        setTimeout(() => {
          router.push("/mini-h5/index/userRegister");
        }, 1500);
      }
    }
  });
}

Vue.prototype.$routerModule = routerModule;
Vue.prototype.$replaceMoudule = replaceMoudule;
Vue.prototype.$queryParams = queryParams;
Vue.prototype.$GetQueryString = GetQueryString;
Vue.prototype.$isEmpty = isEmpty;
Vue.prototype.$getFileUrl = getFileUrl;
Vue.prototype.$isLogin = isLogin;
